import { Typography } from "@mui/material"
import Box from "@mui/material/Box"
import Stack from "@mui/material/Stack"
import { useState } from "react"
import { useTranslation } from "react-i18next"

export type VideoViewerProps = {
    onError?: (error?: any) => void
    src: string
    fallBackSrc: string
}
export default function VideoViewer(props: VideoViewerProps) {

    const { src, onError, fallBackSrc } = props
    const [videoSrc, setVideoSrc] = useState<string>(src)
    const [error, setError] = useState<boolean>(false)
    const handleError = () => {
        setVideoSrc(fallBackSrc)
        setError(true)
        onError?.()
    }
    const { t } = useTranslation()
    return (
        <Stack alignItems="center" spacing={2} sx={{ width: '100%' }}>
            <Box
                sx={[
                    { width: '100%' },
                    error && {
                        width: '200px'
                    }
                ]}
            >
                <video src={videoSrc} controls autoPlay onError={handleError} width="100%"></video>
            </Box>
            {error && (
                <Typography variant="subtitle1" component="div">
                    {t('component.ui.filePreview.video.notAvailable')}
                </Typography>
            )}
        </Stack>
    )
}
